import { DataCache, ForeignKeyRelationship, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { ConfigureReminders, DefaultReminders } from 'data/models/ConfigureReminders';

export class ConfigureRemindersCache extends DataCache {
    ConfigureReminders = PCCollection(ConfigureReminders);

    constructor(data : PCCache) {
        super();

        new SharedKeyRelationship (this.ConfigureReminders, data.Organizations, c => c.Organization, null);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/configurereminders/cache.ts